import { Location } from 'react-router';
import { z } from 'zod';

const loginRedirectStorageKey = 'beforeLogin' as const;

const loginRedirectStorageSchema = z.object({
  pathname: z.string(),
  search: z.string().optional(),
  hash: z.string().optional(),
});

type LoginRedirectStorage = z.infer<typeof loginRedirectStorageSchema>;

export function getLoginRedirect(): LoginRedirectStorage | null {
  const data = localStorage.getItem(loginRedirectStorageKey);
  if (data === null) {
    return null;
  }

  try {
    return loginRedirectStorageSchema.parse(JSON.parse(data));
  } catch {
    clearLoginRedirect();
    return null;
  }
}

export function setLoginRedirect(
  location:
    | (Pick<Location, 'pathname'> & Partial<Pick<Location, 'search' | 'hash'>>)
    | null
) {
  if (location) {
    localStorage.setItem(
      loginRedirectStorageKey,
      JSON.stringify({
        pathname: location.pathname,
        search: location.search,
        hash: location.hash,
      })
    );
  } else {
    localStorage.removeItem(loginRedirectStorageKey);
  }
}

function clearLoginRedirect(): void {
  localStorage.removeItem(loginRedirectStorageKey);
}
